import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/home/HeroSection';
import CategoryGrid from '@/components/home/CategoryGrid';
import AboutSection from '@/components/home/AboutSection';
import ProductGrid from '@/components/home/ProductGrid';
import CTASection from '@/components/home/CTASection';
import ArticleSection from '@/components/home/ArticleSection';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuyspreadsheets.rest';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'OOPBuy Spreadsheet',
    url: SITE_URL,
    description: 'Smart product sourcing and inventory tracking system helping resellers track thousands of SKUs across 14 product categories.',
    inLanguage: 'en',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'OOPBuy Spreadsheet - Smart Product Sourcing & Inventory Tracking System',
    url: SITE_URL,
    description: 'Master the OOPBuy Spreadsheet system for efficient product sourcing, inventory tracking, and spreadsheet management. Learn how the OOPBuy Spreadsheet helps resellers track thousands of SKUs across 14 categories.',
    isPartOf: {
      '@type': 'WebSite',
      name: 'OOPBuy Spreadsheet',
      url: SITE_URL,
    },
    about: {
      '@type': 'Thing',
      name: 'OOPBuy Spreadsheet',
      description: 'A structured data-management framework for product resellers covering 14 categories including Shoes, Hoodies, T-Shirts, Jackets, and Accessories.',
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20with%20organized%20spreadsheet%20dashboard%20on%20laptop%20screen%20surrounded%20by%20product%20catalog%20images%20warm%20natural%20lighting%20editorial%20photography%20style%20neutral%20tones&width=1200&height=630&seq=og-homepage&orientation=landscape',
    },
  };

  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={webpageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ProductGrid />
        <CTASection />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}